import "./Privacy.module.css";
import Header from "@/reusable_sections/Header";
import ProjectOverview from "./sections/ProjectOverview";
import OurPhilosophy from "./sections/OurPhilosophy";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPage() {
  return <div>
      <Header />
      <ProjectOverview />
      <OurPhilosophy />
      <Footer />
    </div>;
}